/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 3 PRO React components
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";
import { useMaterialUIController } from "context";

function DefaultCell({ value, suffix = "" }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <MDTypography
      // variant="body2"
      sx={({ typography: { size, fontWeightBold } }) => ({
        fontSize: size.xs,
        fontWeight: fontWeightBold,
        color: darkMode ? "white" : colors.grey[700],
      })}
    >
      {value}
      {suffix && (
        <MDTypography variant="caption" fontWeight="medium" color="secondary">
          &nbsp;&nbsp;{suffix}
        </MDTypography>
      )}
    </MDTypography>
  );
}

// Typechecking props for the DefaultCell
DefaultCell.propTypes = {
  value: PropTypes.any,
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default DefaultCell;
